import React, { useEffect } from 'react';
import { Col, Form, Input, Row } from 'antd';
import { FormattedMessage } from 'react-intl';
import RichTextInput from 'components/RichTextInput';

import useFormatMessage from 'hooks/useFormatMessage';
import TranslationTabs from 'components/TranslationTabs';
import EditDependencies from './EditDependencies';
import messages from './messages';

const EditText = ({
  survey,
  translations,
  text,
  dependencies,
  dependencyOperator,
  surveyQuestions = [],
  form,
  onSubmit,
}) => {
  const $t = useFormatMessage();

  const initialValues = {
    title: text.title,
    body: text.body,
    dependencies,
    dependencyOperator,
    translations: text.translations?.reduce((obj, t) => {
      obj[t.survey.id] = t;
      return obj;
    }, {}),
  };

  useEffect(() => {
    if (text) {
      form.resetFields();
    }
  }, [text]);

  return (
    <Form layout="vertical" form={form} onFinish={onSubmit} initialValues={initialValues}>
      <Row gutter={48} style={{ margin: '0 -24px' }}>
        <Col span={10}>
          <Form.Item
            name="title"
            label={<FormattedMessage {...messages.textTitle} />}
            rules={[{ required: true, message: $t(messages.textTitleRequired) }]}
          >
            <Input placeholder={$t(messages.textTitlePlaceholder)} />
          </Form.Item>
          <EditDependencies questions={surveyQuestions} />
        </Col>
        <Col span={14} style={{ borderLeft: '1px solid #f0f0f0' }}>
          <TranslationTabs
            primary={survey}
            translations={translations}
            primaryContent={(
              <Form.Item
                name="body"
                rules={[{ required: true, message: $t(messages.textBodyRequired) }]}
              >
                <RichTextInput placeholder={$t(messages.textBodyPlaceholder)} />
              </Form.Item>
            )}
            translationsContent={translations.map(translation => (
              <>
                <Form.Item name={['translations', translation.id, 'id']} noStyle>
                  <input type="hidden" />
                </Form.Item>
                <Form.Item
                  name={['translations', translation.id, 'body']}
                  rules={[{ required: true, message: $t(messages.textBodyRequired) }]}
                >
                  <RichTextInput placeholder={$t(messages.textBodyPlaceholder)} />
                </Form.Item>
              </>
            ))}
            columnSpan={24}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default EditText;
